import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalBase, ModalDialogService } from '@nx-fe/shared-dialogs';
import {
  AccountService,
  AppSettingsService,
  AuthorizationService,
  ILicenceDetails,
  LicenseDetailError,
} from '@nx-fe/services';
import { XsI18nPipe } from '@nx-fe/pipes';
import { xsightVersionInfo } from '../../../../../autogen/src/app/shared/res/autogenerated/version.js';
import { xsightBuildInfo } from '../../../../../autogen/src/app/shared/res/autogenerated/build.js';
import { Subject } from 'rxjs';

@Component({
  selector: 'nx-fe-subscription-info-modal',
  templateUrl: './subscription-info-modal.component.html',
  styleUrls: ['./subscription-info-modal.component.scss'],
})

export class SubscriptionInfoModalComponent extends ModalBase implements OnInit, OnDestroy {
  @Input() tenantId = 'Test';
  @Input() xSightLicensePopupData = '';

  private openingEula = false;

  input: any;
  //hidden:boolean;

   hidden = true;
   old = false;

  public sotiContactUrl = 'http://www.soti.net/';
  private buildInfo: any;
  private versionInfo: any;
  private licenceMessage: string = '';
  public licenseExpired: boolean;
  public copyrightYear: number;
  public licenseUpdated$: Subject<ILicenceDetails> = new Subject<ILicenceDetails>();

  constructor(

    private _modalDialogService: ModalDialogService,
    private appSettingsService: AppSettingsService,
    private accountService: AccountService,
    private authorizationService: AuthorizationService,
    private saI18npipe: XsI18nPipe,
    @Inject('LOCALSTORAGE') private localStorage: Storage
  ) {
    super(_modalDialogService);
    this.versionInfo = xsightVersionInfo;
    this.buildInfo = xsightBuildInfo;
  }

  public imageSource(){
    this.hidden = false ;
    this.old = true;
  }
  public prevSource(){
    this.hidden = true;
    this.old = false;
  }

  public getAppVersionString = (): string => {
    let version = this.saI18npipe.transform('about_AppVersion_Caption');
    version += '20' + this.versionInfo.versionPrefix + this.buildInfo.buildNumber;
    return version;
  };

  public licenseAction = (): void => {
    window.open(this.sotiContactUrl);
    this.close();
  };

  public getLicenseMessage = () => {
    return this.licenceMessage;
  };

  ngOnInit() {
    //let hidden = false;
    if (!this.input) {
      this.input = {
        tenantId: '',
        xSightLicensePopupData: '',
      };
    }
    this.copyrightYear = this.appSettingsService.copyrightYear;
    this.xSightLicensePopupData = this.input['XSightLicensePopup'];
  }

  ngOnDestroy(): void {
    if (this.input.onCancelAction && !this.openingEula) {
      this.input.onCancelAction();
    }
  }

  submit(data: any) {}

  public refreshLicense = (): void => {
    this.accountService.forceRefreshLicense().subscribe(
      (response: ILicenceDetails) => {
        if (response.status === 'Expired') {
          this.redirectToActivation();
        }
        if (response.status === 'Active') {
          let daysRemaining =
            (new Date(response.licenseEndDate).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
          if (daysRemaining < 0) {
            daysRemaining = 0;
          }
          if (Math.ceil(daysRemaining) > 30 && this.localStorage.getItem('ls.noOfDaysRemainingToShowLicensePopup')) {
            this.localStorage.removeItem('ls.noOfDaysRemainingToShowLicensePopup');
          }
        }
        this.licenseUpdated$.next(response);
      },
      (error: LicenseDetailError) => {
        console.error('Failed to refresh license. Error: ' + error);
        if (error === LicenseDetailError.LicenseNotActive) {
          // for not active license, redirect to activation page.
          this.redirectToActivation();
        } else {
          // network error
          this.licenceMessage = this.saI18npipe.transform('about_UpdateLicense_UnableToCheckLicense_Error_Message');
        }
      }
    );
  };

  public isRefreshLicenseButtonAvaliable = (): boolean => {
    return this.authorizationService.isSystemAdmin();
  };

  public isXSightLicensePopup = (): boolean => {
    return this.xSightLicensePopupData === 'XSightLicensePopup';
  };

  private redirectToActivation = () => {
    const url = '/sotixsight/licenceActivation/?redirectUrl=' + encodeURIComponent(window.location.href);
    window.location.assign(url);
  };

  close(data?: any) {
    super.close(data);
  }
}
